import React, { useContext, useEffect, useState } from 'react';
import styles from './AddCompositionAuthorization.module.css';
import useTheme from 'config/useTheme';
import GuiContext from 'config/context/guiContext';
import PluginsContext from 'config/context/pluginsContext';
import AuthenticationContext from 'config/context/authenticationContext';
import { useAddCompositionContext } from 'features/compositions/context/AddCompositionContext';
import { testPrivateKey } from 'utils/validations';
import ActionLoader from 'components/shared/status/ActionLoader';
import ModalInputField from 'components/shared/modal/ModalInputField';
import { ArrowRightIcon } from 'assets/icons';

const AddCompositionAuthorization = () => {
    const { dark } = useTheme();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [pk, setPk] = useState('');
    const { setStep, setPkey } = useAddCompositionContext();
    const { isPermissionValid } = useContext(AuthenticationContext);
    const { getActiveByAccountName } = useContext(PluginsContext);

    const [validField, setValidField] = useState({
        pk: true
    });

    const {
        userData: { guiname }
    } = useContext(GuiContext);

    const isActivePlugin = getActiveByAccountName(guiname)?.active?.includes(7);

    useEffect(() => {
        const checkPermission = async () => {
            await new Promise(resolve => setTimeout(resolve, 1000));

            if (isActivePlugin) {
                const valid = isPermissionValid('active');

                if (valid) {
                    setStep(3);
                }
            }

            setLoading(false);
        };

        checkPermission();
    }, []);

    const goToTransmission = () => {
        const isPkValid = testPrivateKey(pk);
        if (!isPkValid) {
            setError('Invalid private key!');
        }
        setValidField({
            pk: isPkValid
        });

        if (!isPkValid) { return; };

        setPkey(pk);
        setStep(3);
    }

    if (loading) {
        return <div className={styles.mf_authorization}> <ActionLoader text="Authorization checking..." /></div>
    }

    return (
        <div className={`${styles.add_composition_auth} ${dark ? styles.dark : ''}`}>
            <div className={styles.top_line}>
                <div className={styles.title}>Add new composition</div>
            </div>
            <div className={styles.auth_data}>
                <p>
                    {!isActivePlugin ? (
                        <span>HOT KEY plugin is not active.</span>
                    ) : (
                        <span>HOT KEY is active, but no valid key is set.</span>
                    )}
                    <br />
                    Enter your "active" private key to authorize blockchain data transfer. Ensure you're in a secure environment.
                </p>
            </div>
            <div className={styles.insert_pk}>
                <ModalInputField
                    autoFocus={true}
                    privateKey
                    placeholder="Private key"
                    value={pk}
                    setValue={(val) => setPk(val)}
                    valid={validField.pk}
                />
            </div>
            {error && <span className={styles.error_message}>{error}</span>}
            <button disabled={!pk} onClick={() => goToTransmission()} className={styles.submit_btn}>Go to data transmission <ArrowRightIcon /></button>
        </div>
    )
}

export default AddCompositionAuthorization;